export default "__VITE_ASSET__cba34fc8__"